<template>
  <form-organization-branch-editing
    v-bind="$props"
    v-on:submit="onSubmit"
  >
    <template slot="branch-name">
      <input-text
        class="organization-branch-form__field"
        placeholder="Новый"
        title="Название филиала"
        v-bind:required="true"
        v-model="branchName" />
    </template>
  </form-organization-branch-editing>
</template>

<script>
import FormOrganizationBranchEditing from '@/components/FormOrganizationBranchEditing.vue';
import InputText from '@/components/InputText.vue';

/**
 * @description Форма добавления филиала.
 * @type {Vue}
 */
export default {
  components: {
    FormOrganizationBranchEditing,
    InputText,
  },
  data() {
    return {
      /**
       * @description Название филиала.
       * @type {string}
       */
      branchName: '',
    };
  },
  extends: FormOrganizationBranchEditing,
  methods: {
    /**
     * @description Обработать отправку данных.
     * @param {object} data Данные.
     * @returns {void}
     */
    onSubmit(data) {
      this.$emit('submit', { branchName: this.branchName, ...data });
    },
  },
  name: 'FormOrganizationBranchAdding',
};
</script>
